// extracted by css-extract-rspack-plugin
export default {"list":"list-uy141O","item":"item-OzPwpd","ext":"ext-j98adb"};